import { useContext } from 'react';
import SummaryMobile from '../../../ui-components/SummaryMobile';
import { giftcardState } from '../client-state/giftcard-state-context';
import SummaryInfo from '../../../ui-components/SummaryInfo';
import { Row } from '../../../SubComponents/Modals';
import { Text } from '../../../SubComponents/Text';
import TermsWithData from './terms-with-data';
import NewsletterWithData from './newsletter-with-data';
import SummaryMobileConfirmButton from '../../../ui-components/SummaryMobileConfirmButton';
import useLocalize from '../../../Hooks/useLocalize';
import useFormatPrice from '../../../Hooks/use-format-price';
import { formatDuration } from '../../../Utils/utils';
import useLocale from '../../../Hooks/use-locale';
import localizations from '../../../localizations';
import useGiftcardTracking from '../../../Hooks/use-giftcard-tracking';
import useGiftcardPrices from '../../../Hooks/use-giftcard-prices';
import { paymentReducerActionTypes } from '../../../redusers/payment-reducer';
import { isSummaryOpenActionTypes } from '../../../redusers/is-summary-open-reducer';
import { errorReducerActionTypes } from '../../../redusers/error-reducer';
import useGiftcardShop from '../server-data/use-giftcard-shop';

const SummaryMobileWithData = () => {
  const { data: shop } = useGiftcardShop();
  const { state, dispatch } = useContext(giftcardState);
  const localize = useLocalize();
  const formatPrice = useFormatPrice();
  const { languageAsEnum } = useLocale();
  const localization = localizations[languageAsEnum];
  const track = useGiftcardTracking();
  const { giftcardPrices } = useGiftcardPrices();

  const summaryDurationString = shop?.configuration?.hideGiftCardDurations
    ? ''
    : ` • ${formatDuration(state.giftcard.duration, { localization })}`;

  return (
    <SummaryMobile
      heading={localize('product.yourGiftcard')}
      shopName={shop?.name}
      isSummaryOpen={state.isSummaryOpen}
      setSummaryOpen={(isOpen: boolean) =>
        dispatch({ type: isSummaryOpenActionTypes.SET_IS_OPEN, payload: isOpen })
      }
    >
      <Row justifyContent="space-between" mb="2">
        <Text color="#fff">
          {state.giftcard.campaignName
            ? state.giftcard.campaignName
            : `${localize('product.Giftcard')}${summaryDurationString}`}
        </Text>

        <Text color="#fff">
          {giftcardPrices.rentalPrice || giftcardPrices.rentalPrice === 0
            ? formatPrice(giftcardPrices.rentalPrice)
            : '-'}
        </Text>
      </Row>

      <SummaryInfo
        prices={giftcardPrices}
        vouchers={state.vouchers}
        payments={state.payment.payments}
      />

      {!state.payment.showPaymentModal && state.currentStep === 3 && (
        <>
          <TermsWithData textColor="#fff" />

          <NewsletterWithData textColor="#fff" />

          <SummaryMobileConfirmButton
            dependencies={[
              {
                key: 'terms.termsChecked',
                value: true,
                errorType: errorReducerActionTypes.TERMS,
                clickable: true,
              },
              {
                key: 'terms.newsletterSubscribed',
                value: [true, false],
                errorType: errorReducerActionTypes.NEWSLETTER,
                clickable: true,
              },
            ]}
            onClick={() => {
              dispatch({ type: isSummaryOpenActionTypes.SET_IS_OPEN, payload: false });
              dispatch({
                type: paymentReducerActionTypes.UPDATE_SHOW_PAYMENT_MODAL,
                payload: true,
              });

              track({ type: 'CHECKOUT_GIFTCARD', product: state.giftcard, step: 4 });
            }}
            onError={(errorType) => {
              if (errorType) {
                if (errorType === errorReducerActionTypes.TERMS) {
                  dispatch({ type: errorReducerActionTypes.TERMS, payload: 'true' });
                }

                if (errorType === errorReducerActionTypes.NEWSLETTER) {
                  dispatch({ type: errorReducerActionTypes.NEWSLETTER, payload: 'true' });
                }
              }
            }}
          >
            {`${localize('product.goToCheckout')}`}
          </SummaryMobileConfirmButton>
        </>
      )}
    </SummaryMobile>
  );
};

export default SummaryMobileWithData;
